import { combineReducers } from 'redux';
import aktivoReducer from './aktivoReducer';
import myPrivilegesReducer from './myPrivilegesReducer';

export default combineReducers({
  aktivo: aktivoReducer,
  myPrivileges: myPrivilegesReducer,
});
